import { render, staticRenderFns } from "./blackWhite.vue?vue&type=template&id=1d27427e&scoped=true"
import script from "./blackWhite.vue?vue&type=script&lang=js"
export * from "./blackWhite.vue?vue&type=script&lang=js"
import style0 from "./blackWhite.vue?vue&type=style&index=0&id=1d27427e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d27427e",
  null
  
)

export default component.exports